import { ExpressionRuleEditor } from "../ExpressionRuleEditor";
import { BracketedDiv, ExpressionPiece } from "../../Builder/ExpressionStyles";
import { ExpressionValueRenderer } from "../../Builder/ExpressionValueRenderer";
import React from "react";
import { StringTrimExpression } from "../../../rule-engine-core/Expressions/Expressions/String/StringTrimExpression";

export class StringTrimExpressionEditor extends ExpressionRuleEditor<StringTrimExpression> {
    render() {
        return (
            <>
                <ExpressionPiece>
                    <ExpressionPiece>trim</ExpressionPiece>
                    <BracketedDiv>
                        <ExpressionValueRenderer el={this.ruleData!.value1!} />
                    </BracketedDiv>
                </ExpressionPiece>
            </>
        );
    }
}
